import { AxiosResponse } from "axios";
import * as Yup from "yup";
import { propertySchema } from "../schemas/property.schema";
import Cookies from "js-cookie";
import { $http } from "../config/axiosConfig";
import { endpoints } from "../constants/api";

export const fetchPropertiesAsync = async () => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.get(`${endpoints.properties}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const createPropertyAsync = async ({
  values,
}: {
  values: Yup.InferType<typeof propertySchema>;
}) => {
  const isValidFields = await propertySchema.isValid(values);

  if (isValidFields) {
    const token = Cookies.get("token");

    const payload = {
      propertyName: values.name,
      location: values.location,
      Client_tbl_id: values.owner,
    };

    try {
      const data: AxiosResponse = await $http.post(
        endpoints.properties,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return { data: data?.data };
    } catch (error) {
      return error;
    }
  } else {
    return new Response("Invalid fields!", { status: 400 });
  }
};

export const fetchDashboardPropertiesAsync = async () => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.get(
      `${endpoints.propertiesForDashboard}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};
